import axios from "axios";
import {useEffect, useRef, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import AutoComplete from '@mui/material/Autocomplete';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function EditPackRoom() {
    const {room_id} = useParams();
    const [packcats, setpackcats] = useState([]);
    const [insur, setInsur] = useState([]);
    const [items, setItems] = useState([]);
    const inputRefs = useRef([]);
    const [rows, setRows] = useState([]);
    const [subdata, setsubData] = useState([]);
    const [RoomData, setRoomData] = useState({
        "pack": '',
        "insur": '',
        "room": '',
        "roomamount": '',
        "days": '',
        "status": '',
        "addedby": '',
        "ip_add": ''
    });
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [RoomResponse] = await Promise.all([
                    axios.get(`${baseUrl}room-type/`),
                ]);
                setItems(RoomResponse.data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);
    const handleChange = (event) => {
        setRoomData({
            ...RoomData,
            [event.target.name]: event.target.value
        });
    }
    const handleKeyDown = (e, index) => {
        const newRows = [...rows];
        switch (e.keyCode) {
            // Handle Shift key
            case 16:
                e.preventDefault();
                if (index === rows.length - 1) {
                    newRows.push({id: '', room: '', days: '', amount: ''});
                }
                break;
            case 90:
                e.preventDefault();
                newRows.splice(index, 1);
                break;
            // Handle arrow up key
            case 38:
                e.preventDefault();
                if (newRows[index].selectedItem === 0) {
                    newRows[index].selectedItem = items.length - 1;
                } else {
                    newRows[index].selectedItem--;
                }
                setRows(newRows);
                break;
            // Handle arrow down key
            case 40:
                e.preventDefault();
                if (newRows[index].selectedItem === items.length - 1) {
                    newRows[index].selectedItem = 0;
                } else {
                    newRows[index].selectedItem++;
                }
                setRows(newRows);
                break;
            default:
                break;
        }
        setRows(newRows);
    };
    const handleSelect = (value, index) => {
        // Check if value is undefined or null
        if (value === undefined || value === null) {
            // Handle the scenario where the value is cleared or backspaced
            const newRows = [...rows];
            newRows[index] = {id: '', room: '', days: '', amount: ''};
            setRows(newRows);
        } else {
            // Handle the selection
            const selectedItem = items.find(item => item.room === value);
            if (selectedItem) {
                const newRows = [...rows];
                newRows[index] = {
                    id: selectedItem.id,
                    room: selectedItem.room,
                    days: selectedItem.days,
                    amount: selectedItem.amount
                };
                setRows(newRows);
            }
        }
    };
    const handleAmountChange = (e, index) => {
        const newRows = [...rows];
        newRows[index].amount = parseFloat(e.target.value) || 0;
        setRows(newRows);
    };
    const handleDaysChange = (e, index) => {
        const newRows = [...rows];
        let newDays = parseInt(e.target.value) || 0;
        if (newDays < 1) {
            newDays = 1; // Set days to 1 if the new value is less than 1
        }
        const oldDays = newRows[index].days;
        const oldAmount = parseFloat(newRows[index].amount) || 0;
        newRows[index].days = newDays;
        newRows[index].amount = (oldAmount / oldDays) * newDays; // Update the amount based on the new days
        setRows(newRows);
    };
    const handleAddRow = () => {
        const newRows = [...rows, {id: '', room: '', days: '', amount: ''}];
        setRows(newRows);
    };
    useEffect(() => {
        inputRefs.current[inputRefs.current.length - 1]?.focus();
    }, [rows]);
    const handleDeleteRow = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
        inputRefs.current.splice(index, 1);
    };
    useEffect(() => {
        try {
            axios.get(baseUrl + 'create-pack/')
                .then(function (response) {
                    setpackcats(response.data);
                });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(`${baseUrl}insur-cmpy/`)
                .then(response => {
                    setInsur(response.data);
                })
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        try {
            axios.get(baseUrl + 'edit-pack-room/' + room_id)
                .then(function (response) {
                    setRoomData({
                        insur: response.data.insur.id,
                        pack: response.data.pack.id,
                        room: response.data.room,
                        roomamount: response.data.roomamount,
                        days: response.data.days,
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('pack', RoomData.pack);
        _formData.append('insur', RoomData.insur);
        _formData.append('room', rows.map(row => row.id).join(','));
        _formData.append('days', rows.map(row => row.days).join(','));
        _formData.append('roomamount', rows.map(row => row.amount).join(','));
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.put(baseUrl + 'edit-pack-room/' + room_id, _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    setTimeout(() => {
                        window.location.href = ('/pack-room');
                    }, 2000);
                });
        } catch (error) {
            console.log(error);
        }
    };
    const RoomIds = RoomData.room ? RoomData.room.split(',') : [];
    const RoomAmounts = RoomData.roomamount ? RoomData.roomamount.split(',') : [];
    const RDays = RoomData.days ? RoomData.days.split(',') : [];
    const fetchRoomData = async () => {
        try {
            const requests = RoomIds.map((id, index) =>
                axios.get(`${baseUrl}edit-room-type/${id}`).then(response => ({
                    ...response.data,
                    days: parseInt(RDays[index]) // Include the days value from RDays
                }))
            );
            const responses = await Promise.all(requests);
            setRows(responses);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        fetchRoomData();
    }, [RoomData]);
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit Room Package</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="pack" className="form-label">Package SubCategory</label>
                                    <select name="pack" value={RoomData.pack} onChange={handleChange}
                                            className="form-control">
                                        <option>Choose Package SubCategory</option>
                                        {packcats.map((category, index) => {
                                            return <option key={index} value={category.id}>{category.packsubcat}
                                            </option>
                                        })}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="insur" className="form-label">Insurance</label>
                                    <select name="insur" value={RoomData.insur} onChange={handleChange}
                                            className="form-control">
                                        <option>Choose Insurance</option>
                                        {insur.map((insurer, index) => {
                                            return <option key={index} value={insurer.id}>
                                                {insurer.company}
                                            </option>
                                        })}
                                    </select>
                                </div>

                                <div className="table-responsive">
                                    <table className="erp-table-modern">
                                        <thead>
                                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Days</th>
                                            <th>Total</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        {rows.map((entry, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="ms-2 me-5 mt-4"
                                                        style={{width: 80}}
                                                        name="ltest_id"
                                                        value={entry.id}
                                                        onChange={(e) => handleChange(e, index, 'id')}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <AutoComplete
                                                        className="form-control mt-2"
                                                        options={items.map(item => item.room)} // Replace with the data fetched from the server
                                                        value={entry.room} // Set the value based on the Room entry
                                                        onChange={(event, value) => handleSelect(value, index)}
                                                        onInputChange={(event, newInputValue) => {
                                                            setRows(prevRows => {
                                                                const updatedRows = [...prevRows];
                                                                // Check if the row at the current index exists
                                                                if (updatedRows[index]) {
                                                                    updatedRows[index].room = newInputValue;
                                                                } else {
                                                                    // If the row doesn't exist, log an error or handle the case appropriately
                                                                    console.error(`Row at index ${index} is undefined.`);
                                                                }
                                                                return updatedRows;
                                                            });
                                                        }}
                                                        onKeyDown={e => handleKeyDown(e, index)}
                                                        renderInput={(params) => (
                                                            <div ref={params.InputProps.ref}>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    {...params.inputProps}
                                                                    focused autoFocus
                                                                    fullWidth
                                                                    style={{
                                                                        width: 300,
                                                                        background: "#F7EEFF",
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        ref={(el) => inputRefs.current[index] = el}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="ms-2 me-5"
                                                        value={entry.days}
                                                        name="days"
                                                        min={1}
                                                        style={{width: 100}}
                                                        onChange={(e) => handleDaysChange(e, index)} // Corrected onChange handler
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="ms-2 me-5"
                                                        value={entry.amount}
                                                        name="amount"
                                                        style={{width: 100}}
                                                        onChange={handleChange}
                                                        onChange={(e) => handleAmountChange(e, index)}

                                                    />
                                                </td>
                                                <td>
                                                    <button className="btn btn-danger" type="button"
                                                            onClick={() => handleDeleteRow(index)}>Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}

                                        </tbody>
                                    </table>
                                    <button className="btn btn-success addmore mt-4" type="button"
                                            onClick={handleAddRow}>Add More
                                    </button>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <button type="button" onClick={formSubmit} className="btn btn-primary">Submit
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default EditPackRoom;